class LurenHeroVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    if (!this.video || !this.button) return;
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.wantsPlayback = !this.motion.matches;
    this.inView = false;
    this.video.muted = true;
    this.video.loop = true;
    this.video.playsInline = true;
    this.video.controls = false;
    this.button.hidden = false;
    this.button.addEventListener('click', () => {
      this.wantsPlayback = this.video.paused;
      this.sync();
    }, options);
    this.video.addEventListener('playing', () => {
      this.setAttribute('data-started', '');
      this.updateButton();
    }, options);
    this.video.addEventListener('pause', () => this.updateButton(), options);
    this.video.addEventListener('error', () => {
      this.wantsPlayback = false;
      this.removeAttribute('data-started');
      this.button.hidden = true;
    }, options);
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) this.wantsPlayback = false;
      this.sync();
    }, options);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(entries => {
      this.inView = entries[0].isIntersecting;
      this.sync();
    }, { threshold: 0.15 });
    this.observer.observe(this);
    this.updateButton();
  }

  sync() {
    if (!this.isConnected) return;
    if (this.wantsPlayback && this.inView && !document.hidden) {
      const play = this.video.play();
      play?.catch(() => this.updateButton());
    } else {
      this.video.pause();
    }
    this.updateButton();
  }

  updateButton() {
    this.button.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.abort?.abort();
    this.video?.pause();
  }
}

if (!customElements.get('luren-hero-video')) customElements.define('luren-hero-video', LurenHeroVideo);
